import React from 'react';
import { Link } from 'react-router-dom';
function Header(){
    return( <>
    <div className='Footer'>
        <div className='container'>
            <div className='row-box'>
                <div className='col4'>
                    <div className='Headingtxt'>
                        <p>Contact Us</p>
                        <div className='ShapeBox'>
                            <span className='shape1'></span>
                            <span className='shape2'></span>
                            <span className='shape3'></span>
                        </div>
                    </div >
                    <form>
                        <div className='FormGroup'>
                            <input className='formcontrol' type='text' placeholder='Your Name'/>
                        </div>
                        <div className='FormGroup'>
                            <input className='formcontrol' type='email' placeholder='Your E-Mail'/>
                        </div>
                        <div className='FormGroup'>
                            <textarea className='formcontrol' rows={4} placeholder='Your Message'></textarea>
                        </div>
                        <div className='FormGroup'>
                            <input type='submit' value='Submit' className='Button'/>
                        </div>
                    </form>
                </div>

                <div className='col4 Center'>
                    <div className='Headingtxt'>
                        <p>Find us on Social Media</p>
                        <div className='ShapeBox'>
                            <span className='shape1'></span>
                            <span className='shape2'></span>
                            <span className='shape3'></span>
                        </div>
                    </div>
                    <ul className='Listing'>
                        <li><Link to="#"> <img src={require('../images/facebook.png')} alt='Fackbook' /> Fackbook</Link> </li>
                        <li><Link to="#"> <img src={require('../images/insta.png')} alt='Instagram' /> Instagram</Link> </li>
                        <li><Link to="#"> <img src={require('../images/youtube.png')} alt='Youtube' /> Youtube</Link> </li>
                        <li><Link to="#"> <img src={require('../images/twitter.png')} alt='X (ehem. Twitter)' /> X (ehem. Twitter) </Link> </li>
                    </ul>
                    <div className='spacer'></div>

                    <div className='Headingtxt'>
                        <p>Join our Team</p>
                        <div className='ShapeBox'>
                            <span className='shape1'></span>
                            <span className='shape2'></span>
                            <span className='shape3'></span>
                        </div>
                    </div>

                    <ul className='Listing'>
                        <li><Link to="#"> <img src={require('../images/Sendmessage.png')} alt='Send message' /> Send message</Link> </li>
                    </ul>

                    <div className='spacer'></div>

                    <div className='Headingtxt'>
                        <p>Contact information</p>
                        <div className='ShapeBox'>
                            <span className='shape1'></span>
                            <span className='shape2'></span>
                            <span className='shape3'></span>
                        </div>
                    </div>

                    <ul className='Listing'>
                        <li><Link to="#"> <img src={require('../images/whatsapp.png')} alt='(0049) 123 45 67 8 9' /> (0049) 123 45 67 8 9</Link> </li>
                        <li><Link to="#"> <img src={require('../images/Sendmessage.png')} alt='info@seitenurl . de' /> info@seitenurl . de</Link> </li>
                    </ul>

                </div>

                <div className='col4'>
                    <div className='Headingtxt'>
                        <p>Rechtiliches</p>
                        <div className='ShapeBox'>
                            <span className='shape1'></span>
                            <span className='shape2'></span>
                            <span className='shape3'></span>
                        </div>
                    </div>
                    <ul className='Listing'>
                        <li><Link to="#"> <img src={require('../images/shape.png')} alt='Impressum' /> Impressum</Link> </li>
                        <li><Link to="#"> <img src={require('../images/shape.png')} alt='Datenschutz' /> Datenschutz</Link> </li>
                        <li><Link to="#"> <img src={require('../images/shape.png')} alt='Noch ein Link' /> Noch ein Link</Link> </li>
                        <li><Link to="#"> <img src={require('../images/shape.png')} alt='vielleicht noch einer' /> vielleicht noch einer </Link> </li>
                        <li><Link to="#"> <img src={require('../images/shape.png')} alt='den hier auch' /> den hier auch</Link> </li>
                    </ul>

                    <div className='spacer'></div>

                    <div className='LogoIcon'><img src={require('../images/logo-center.webp')} alt='logo' /></div> 

                </div>

            </div>
            <div className='FooterBottom'>
                <p>Copyright © 2024 Digital Heroes . All rights reserved.</p>
            </div>
        </div>
    </div>
    </>
    )     
}
export default Header;